import { onLoad } from "@otto-ec/global-resources/dom";
import { runWithRenderSlice } from "@otto-ec/global-resources/core";
import { getNextParentElement } from "./getNextParentElement";

/**
 *
 *
 *
 *
 *
 */
export function currentZIndex(element: HTMLElement | null): number {
  if (!element) return 0;
  const { zIndex } = window.getComputedStyle(element);
  return zIndex === "auto" ? currentZIndex(getNextParentElement(element)) : parseInt(zIndex, 10);
}

export const useCurrentZIndex = (host: HTMLElement): { current: number } => {
  const state = $state({ current: 0 });

  onLoad.subscribe(() =>
    runWithRenderSlice(() => {
      state.current = currentZIndex(host);
    }),
  );

  return state;
};
